'use client'

import React from 'react'
import { useTheme } from 'styled-components'

import { Checkbox as CheckboxIcon } from '../../../icons'
import type { Size } from '../types'
import { CheckboxContainer, Container, InternalCheckbox } from './styles'

export interface CheckboxInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  /**
   * Indeterminate state
   */
  indeterminate?: boolean

  /**
   * Checkbox size
   */
  size?: Size
}

export const CheckboxInput = React.forwardRef(
  (
    {
      className,
      checked,
      indeterminate = false,
      disabled,
      size = 'large',
      onChange,
      ...props
    }: CheckboxInputProps,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    const theme = useTheme()

    return (
      <Container className={className}>
        {onChange && (
          <InternalCheckbox
            ref={ref}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            {...props}
          />
        )}

        <CheckboxContainer checked={checked} disabled={disabled} size={size}>
          <CheckboxIcon
            type={
              indeterminate
                ? 'indeterminate'
                : checked
                ? 'checked'
                : 'unchecked'
            }
            fill={
              indeterminate || checked
                ? theme.colors.red['01']
                : theme.colors.gray['04']
            }
          />
        </CheckboxContainer>
      </Container>
    )
  },
)

CheckboxInput.displayName = 'CheckboxInput'
